import React from 'react';
import { Project } from '@material-bank/projects-api';
import { useProjectsProvider } from '@material-bank/projects-utils';
import { useIntl } from 'react-intl';
import {
  Button,
  ArrowPushDownIcon,
  DialogFooter,
} from '../../../../../../UILibrary';
import { definedTranslation } from '../../i18n';
import { ChangeProjectDropDown } from '../ChangeProjectDropDown';

type PreviewFilesDialogFooterProps = {
  currentProject: Project | null;
  isDownloadDisabled?: boolean;
  totalFilesChecked: number;
  onProjectChange: (projectId: string) => void;
  onDonwnload: () => void;
};

export function PreviewFilesDialogFooter({
  currentProject,
  isDownloadDisabled,
  totalFilesChecked,
  onProjectChange,
  onDonwnload,
}: PreviewFilesDialogFooterProps) {
  const intl = useIntl();
  const { activeProjects } = useProjectsProvider();

  return (
    <DialogFooter className="sm:hidden justify-between items-center">
      <ChangeProjectDropDown
        showSelectedProject={true}
        projects={activeProjects}
        currentProject={currentProject}
        onProjectChange={onProjectChange}
        openDirection="top"
      />
      <Button
        variant="primary"
        disabled={isDownloadDisabled}
        onClick={onDonwnload}
      >
        <ArrowPushDownIcon />
        {totalFilesChecked > 1
          ? intl?.formatMessage(
              definedTranslation.previewFiles.downloadFilesBtn,
            )
          : intl?.formatMessage(
              definedTranslation.previewFiles.downloadFileBtn,
            )}
      </Button>
    </DialogFooter>
  );
}
